"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer id="footer" ref={ref} className="bg-primary-light py-12 transition-opacity duration-500" style={{
    opacity: isVisible ? 1 : 0
  }}>
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">

          {}
          <p className="text-sm text-foreground/70 text-center md:text-left">
            © 2026 Lucía & Kike. Todos los derechos reservados.
          </p>

          {}
          <nav className="flex gap-6 items-center">
            <Link to="https://dondeseacabaelmar.com/" className="text-sm text-foreground/70 hover:text-foreground transition-colors duration-200">
              Inicio
            </Link>

            <Link to="https://dondeseacabaelmar.com/privacidad/" className="text-sm text-foreground/70 hover:text-foreground transition-colors duration-200">
              Privacidad
            </Link>

            <Link to="https://dondeseacabaelmar.com/terminos/" className="text-sm text-foreground/70 hover:text-foreground transition-colors duration-200">
              Términos
            </Link>
          </nav>

        </div>
      </div>
    </footer>;
}